<template>
    <div>
        <a
            :href="`//${$page.props.company_info.website}`"
            class="my-4"
            :class="{ 'text-h6': large }"
        >
            <v-icon :large="large">mdi-web</v-icon>
            {{ $page.props.company_info.website }}
        </a>
        <a
            :href="`mailto:${$page.props.company_info.email}`"
            class="my-4"
            :class="{ 'text-h6': large }"
        >
            <v-icon :large="large">mdi-email</v-icon>
            {{ $page.props.company_info.email }}
        </a>

        <a
            :href="`tel:${$page.props.company_info.int_phone}`"
            class="my-4"
            :class="{ 'text-h6': large }"
        >
            <v-icon :large="large">mdi-phone</v-icon>
            {{ $page.props.company_info.phone }}
        </a>
    </div>
</template>

<script>
export default {
    name: "CompanyContactInfo",

    props: {
        large: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
